// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import { Header } from "components/elements";
import { RadioGroupField, UploaderField } from "components/form/fields";
import { Column } from "components/layout";
import {
  FIELDS,
  GRAPHICS_DIMENSIONS,
  SECTIONS,
  RADIO_DEFAULT,
} from "pages/Snap/_shared/constants";
import { cropImage } from "utils/image";

const STATIC_TEXT = {
  LOGO_FORMATS: ", PNG OR JPEG",
  BACKGROUND_FORMATS: ", JPEG",
};

const GRAPHICS_FIELDS = [
  {
    name: FIELDS.LOGO.name,
    label: FIELDS.LOGO.label,
    accept: GRAPHICS_DIMENSIONS.LOGO.formats,
    info: `${GRAPHICS_DIMENSIONS.LOGO.width} x ${GRAPHICS_DIMENSIONS.LOGO.height}${STATIC_TEXT.LOGO_FORMATS}`,
    imageValidationOptions: {
      minWidth: GRAPHICS_DIMENSIONS.LOGO.width,
      minHeight: GRAPHICS_DIMENSIONS.LOGO.height,
      maxSize: GRAPHICS_DIMENSIONS.LOGO.size,
    },
    dataTestId: "logo-field",
    graphicDimensions: [
      GRAPHICS_DIMENSIONS.LOGO.width,
      GRAPHICS_DIMENSIONS.LOGO.height,
    ],
  },
  {
    name: FIELDS.BACKGROUND.name,
    label: FIELDS.BACKGROUND.label,
    accept: GRAPHICS_DIMENSIONS.BACKGROUND.formats,
    info: `${GRAPHICS_DIMENSIONS.BACKGROUND.width} x ${GRAPHICS_DIMENSIONS.BACKGROUND.height}${STATIC_TEXT.BACKGROUND_FORMATS}`,
    imageValidationOptions: {
      minWidth: GRAPHICS_DIMENSIONS.BACKGROUND.width,
      minHeight: GRAPHICS_DIMENSIONS.BACKGROUND.height,
      maxSize: GRAPHICS_DIMENSIONS.BACKGROUND.size,
      validateAspectRatio: true,
    },
    dataTestId: "background-field",
    graphicDimensions: [
      GRAPHICS_DIMENSIONS.BACKGROUND.width,
      GRAPHICS_DIMENSIONS.BACKGROUND.height,
    ],
  },
];

export const SnapGraphics = ({ appId }) => {
  return (
    <Column>
      <Header color="secondary" uppercase={true} bold={true}>
        {SECTIONS.GRAPHICS.header}
      </Header>
      {GRAPHICS_FIELDS.map(
        ({
          name,
          imageValidationOptions,
          dataTestId,
          graphicDimensions,
          ...uploaderFieldProps
        }) => (
          <UploaderField
            {...uploaderFieldProps}
            key={dataTestId}
            name={`${appId}.${name}`}
            imageValidationMetadata={imageValidationOptions}
            preprocess={(blobUrl, type) =>
              cropImage(blobUrl, type, ...graphicDimensions)
            }
            required={false}
            dataTestId={dataTestId}
          />
        )
      )}
      <RadioGroupField
        name={`${appId}.${FIELDS.AUTODARKEN_BG.name}`}
        label={FIELDS.AUTODARKEN_BG.label}
        inline={true}
        values={RADIO_DEFAULT}
        dataTestId="autodarken-radio-group"
        required={false}
      />
    </Column>
  );
};

SnapGraphics.propTypes = {
  appId: PropTypes.string.isRequired,
};
